import { RouteTrack } from './utility.model';

export function getAdobeSiteSection(url: string): RouteTrack {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (url) {
    case '/secure/commercial/book-of-business?type=currentbusiness':
      return {
        channel: 'Book of Business',
        pageName: 'Current Business',
      };
    case '/secure/commercial/book-of-business?type=requestforproposal':
      return {
        channel: 'Book of Business',
        pageName: 'Request for Proposals',
      };
    case '/secure/commercial/compensation':
      return {
        channel: 'Compensation',
        pageName: 'Compensation Search',
      };
    case '/secure/commercial/compensation/manage':
      return {
        channel: 'Compensation',
        pageName: 'Manage Compensation Access',
      };
    case '/secure/commercial/compensation?type=client-compensation-reports':
      return {
        channel: 'Compensation',
        pageName: 'Client Compensation Reports',
      };
    case '/secure/commercial/learning':
      return {
        channel: 'Learning Center',
        pageName: 'Producer Learning Center',
      };
    case '/secure/commercial/solutions-insights':
      return {
        channel: 'Solutions and Insights',
        pageName: 'Solutions and Insights Landing',
      };
    case '/secure/commercial/funding':
      return {
        channel: 'Solutions and Insights',
        pageName: 'Funding Solution Highlights',
      };
    case '/secure/ma/compensation':
      return {
        channel: 'Medicare Advantage',
        pageName: 'Compensation and Commission Statements',
      };
    case '/secure/broker-messages':
      return {
        channel: 'Messages',
        pageName: 'My Messages',
      };
    case '/secure/pdp-home':
      return {
        channel: 'PDP Home',
        pageName: 'Prescription Drug Plan',
      };
    case '/public/login':
      return {
        channel: 'Login',
        pageName: 'Guest Login',
      };
    case '/public/forgot-username':
      return {
        channel: 'Login',
        pageName: 'Forgot your username',
      };
    case '/public/forgot-username/contact-method':
      return {
        channel: 'Forgot Username',
        pageName: 'where to send code',
      };
    case '/public/forgot-password':
      return {
        channel: 'Login',
        pageName: 'Forgot your password',
      };
    case '/public/forgot-password/contact-options':
      return {
        channel: 'Forgot Password',
        pageName: 'choose password reset method',
      };
    case '/public/forgot-password/email-confirmation':
      return {
        channel: 'Forgot Password',
        pageName: 'check your email',
      };
    case '/public/registration':
      return {
        channel: 'Registration',
        pageName: 'Enter your Access Code',
      };
    case '/public/registration/setup-contact':
      return {
        channel: 'Registration',
        pageName: 'Set up Your Contact Methods',
      };
    case '/public/registration/username-password':
      return {
        channel: 'Registration',
        pageName: 'Create Username and Password',
      };
    case '/public/registration/security-question':
      return {
        channel: 'Registration',
        pageName: 'Security Question',
      };
    case '/public/registration/terms-conditions':
      return {
        channel: 'Registration',
        pageName: 'Terms and Conditions',
      };
    case '/public/registration/reqSent':
      return {
        channel: 'Registration',
        pageName: 'Your request was sent',
      };
    case '/public/registration/request-access-code':
      return {
        channel: 'Registration',
        pageName: 'Request an Access Code',
      };
    case '/public/mfa/choose-factor':
      return {
        channel: 'MFA',
        pageName: 'Choose Contact point',
      };
    case '/public/mfa/enroll':
      return {
        channel: 'MFA',
        pageName: 'MFA Setup multifactor authentication',
      };
    case '/public/mfa/verify':
      return {
        channel: 'MFA',
        pageName: 'Enter your code',
      };
    case '/secure/security-profile':
      return {
        channel: 'Profile',
        pageName: 'Security Profile',
      };
    case '/secure/csb/incentives':
      return {
        channel: 'CSB',
        pageName: 'Sales Promotions',
      };
    case '/secure/security-profile/password':
      return {
        channel: 'Profile',
        pageName: 'Change Password',
      };
    case '/secure/security-profile/mobile-phone':
      return {
        channel: 'Profile',
        pageName: 'Change your mobile phone number',
      };
    case '/secure/security-profile/email':
      return {
        channel: 'Profile',
        pageName: 'Change your email address',
      };
    case '/secure/security-profile/security-question':
      return {
        channel: 'Profile',
        pageName: 'Change Security Question',
      };
    case '/secure/medicare-medicaid-eligibility':
      return {
        channel: 'Medicare Advantage',
        pageName: 'Medicare/Medicaid Eligibility',
      };
    case '/public/campaign?name=kaplan':
      return {
        channel: 'Registration',
        pageName: 'Commercial Kaplan',
      };
    case '/secure/home/contact-us':
      return {
        channel: 'Home',
        pageName: 'Online Access Support',
      };
    case '/secure/home':
    default:
      return {
        channel: 'Home',
        pageName: 'Dashboard',
      };
  }
}
